import { routes } from '../routes/routes';

export const PLANS = [
  {
    id: 'basic',
    name: 'BASIC',
    icon: '../../../../../assets/icons/theme_icons/medal (2).png',
    tagline: 'For Essential Wellness',
    description:
      'Essential health tips for everyday well-being—simple, smart and affordable.',
    included: [' Health Tips'],

    subIcons: [
      {
        img: '../../../../../assets/img/doc-tips.webp',
        class: 'doctors-tips',
      },
      {
        img: '../../../../../assets/img/doctor-notes.webp',
        class: 'doctors-note',
      },
      {
        img: '../../../../../assets/img/doctors-sister.webp',
        class: 'two-doctors',
      },
    ],
  },
  {
    id: 'smart',
    name: 'SMART',
    icon: '../../../../../assets/icons/theme_icons/medal.png',
    tagline: 'For Smarter Protection',
    description: 'Virtual care and emergency response when you need it most.',
    included: [
      ' Health Tips',
      ' Telemedicine Consultations',
      ' Road Ambulance',
    ],
    subIcons: [
      {
        img: '../../../../../assets/img/heart-break.webp',
        class: 'heart-break',
      },
      {
        img: '../../../../../assets/img/ambulance-card.webp',
        class: 'ambulance-card',
      },
      {
        img: '../../../../../assets/img/mobile-doctor.webp',
        class: 'mobile-doctor',
      },
    ],
  },
  {
    id: 'elite',
    name: 'ELITE',
    icon: '../../../../../assets/icons/theme_icons/medal.png',
    tagline: 'Enhanced health coverage',
    description:
      'Enhanced health coverage with medication, telemedicine, and ambulance support.',
    included: [
      ' Health Tips',
      ' Telemedicine Consultations',
      ' Road Ambulance',
      ' Drugs',
    ],
  },
  {
    id: 'ultimate',
    name: 'ULTIMATE',
    icon: '../../../../../assets/icons/theme_icons/medal.png',
    tagline: 'Enhanced health coverage',
    description:
      'Enhanced health coverage with medication, telemedicine, and ambulance support.',
    included: [
      ' Health Tips',
      ' Telemedicine Consultations',
      ' Road Ambulance',
      ' Drugs',
    ],
  },
  {
    id: 'premium',
    name: 'PREMIUM',
    icon: '../../../../../assets/icons/theme_icons/premium-icon.webp',
    tagline: 'For Exceptional Care',
    description: 
    ' ',
    included: [
      ' Health Tips',
      ' Ambulance Services',
      ' Remote Consultations',
      ' Drugs(Prescribed drugs only)',
      ' Physical Consultations(Normal & Emergency)',
    ],

    subIcons: [
      {
        img: '../../../../../assets/icons/theme_icons/hand-plus.webp',
        class: 'hand-plus',
      },
    ],
  },
];

export const SUBSCRIPTION_PLANS = [
  {
    id: 'daily',
    name: 'Daily',
    description:
      'This subscription is valid for 1 day. After that period, you will need to renew it again.',
    priceZWG: '1 ZWG',
    priceUSD: '1 USD',
  },
  {
    id: 'weekly',
    name: 'Weekly',
    description:
      'This subscription is valid for 7 days. After that period, you will need to renew it again.',
    priceZWG: '7 ZWG',
    priceUSD: '7 USD',
  },
  {
    id: 'monthly',
    name: 'Monthly',
    description:
      'This subscription is valid for 1 month. After that period, you will need to renew it again.',
    priceZWG: '30 ZWG',
    priceUSD: '30 USD',
  },
  {
    id: 'biannually',
    name: 'Bi-Annually',
    description:
      'This subscription is valid for 6 months. After that period, you will need to renew it again.',
    priceZWG: '180 ZWG',
    priceUSD: '180 USD',
  },
  {
    id: 'annually',
    name: 'Annually',
    description:
      'This subscription is valid for 1 year. After that period, you will need to renew it again.',
    priceZWG: '360 ZWG',
    priceUSD: '365 USD',
  },
];

export const MENU_LIST = [
  {
    label: 'Subscription',
    icon: 'assets/img/subscription.png',
    route: routes.subscription,
  },
  {
    label: 'Ambulance',
    icon: 'assets/img/ambulance.png',
    route: routes.ambulance,
  },
  {
    label: 'Telemedicine Consultation',
    icon: 'assets/img/consultation.png',
    route: routes.telemedi,
    active: true,
  },
  // {
  //   label: 'Accounts',
  //   icon: 'assets/img/account-settings.png',
  //   route: null, // Static or future route
  // },
  {
    label: 'Maisha HealthAi Records',
    icon: 'assets/img/medical_records.png',
    route: routes.medicalRecords,
  },
  {
    label: 'Profile Settings',
    icon: 'assets/img/profile.png',
    route: routes.profileSettings,
  },
  {
    label: 'Log out',
    icon: 'assets/img/logout.png',
    route: null,
    action: 'logout',
  },
];

export const FAQ_LIST = [
  {
    question: 'How do I join Maisha HealthAi?',
    answer: [
      'You can subscribe by dialing *147# or calling 147. Subscriptions are also available through our website and other supported channels like IVR, USSD and SMS.',
    ],
  },
  {
    question: 'What services does Maisha HealthAi cover?',
    answer: [
      'Your subscription provides access to:',
      '• Daily Health Tips via SMS',
      '• Road Ambulance Evacuation',
      '• Telemedicine access through Dial-A-Doc (147)',
      '• Virtual Pharmacy (coming soon)',
      '• Physical Doctor Consultations (coming soon)',
    ],
  },
  {
    question: 'How many people are covered under one subscription?',
    answer: [
      'Each subscription covers one individual. However, dependents can be added for an additional fee depending on the selected bundle.',
    ],
  },
  {
    question: 'Do I get a refund if I don’t use the service?',
    answer: [
      'No, subscription fees are non-refundable. Once a plan is purchased, cancellation is not possible. The membership fee ensures unlimited access to the included services during your subscription period.',
    ],
  },
  {
    question: 'Is there a waiting period before I can use the services?',
    answer: [
      'Yes. A waiting period of 3 months applies to all services except Daily Health Tips, which are available immediately.',
    ],
  },
  {
    question: 'How many Dial-A-Doc consultations am I entitled to?',
    answer: ['Each member is eligible for up to 12 consultations per year.'],
  },
  {
    question: 'Who will I speak to when I call Dial-A-Doc?',
    answer: ['All consultations are conducted by qualified medical doctors.'],
  },
  {
    question: 'Who can access Dial-A-Doc consultations?',
    answer: [
      'Only registered, active, and eligible members (including added dependents) are entitled to consultations. Services cannot be accessed on behalf of non-registered individuals.',
    ],
  },
  {
    question: 'How do I receive my prescription?',
    answer: [
      'The doctor will share it via contact methods such as SMS, Email, Web  and your prescription will be sent accordingly.',
    ],
  },
  {
    question: 'What are the operating hours of Dial-A-Doc?',
    answer: ['The service is available from 8:00 AM to 5:00 PM.'],
  },
  {
    question: 'How many ambulance trips am I allowed per year?',
    answer: [
      'There is no set limit. However, ambulances are only dispatched in genuine life- or limb-threatening emergencies. All ambulance calls are free of charge.',
    ],
  },
  {
    question: 'What conditions do not qualify for medical evacuation?',
    answer: [
      '• Minor illnesses that can be managed via Dial-A-Doc',
      '• Cases where the member can travel safely to a nearby facility',
      '• Injuries caused by self-harm, suicide attempts, or activities prohibited under the Common Law of Zimbabwe',
    ],
  },
  {
    question: 'What conditions qualify for medical evacuation?',
    answer: [
      'Medical evacuation is strictly for life- or limb-threatening emergencies.',
    ],
  },
  {
    question: 'Can I choose the hospital I want to be taken to?',
    answer: [
      'Patients are transported to the nearest appropriate medical facility capable of treating their condition.',
    ],
  },
  {
    question: 'Does Maisha HealthAi cover hospital transfers?',
    answer: ['No. The service covers primary emergency calls only.'],
  },
  {
    question: 'What number should I call for consultations?',
    answer: ['Dial 147 using your registered Econet mobile number.'],
  },
];

export const CONSTANT = {
  CONSULTANT_NOTE: "To ensure your consultation, kindly complete the payment soon — slots are limited and may be booked quickly."
};

